'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import UITag from 'UIComponents/tag/UITag';
import RouterFilterButton from './RouterFilterButton';
import { useEmbedContext } from '../../hooks/useEmbedContext';

const RouterFilterTagButton = (_ref) => {
  let {
    children,
    inline
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["children", "inline"]);

  const {
    isEmbedded
  } = useEmbedContext();

  const renderedTag = /*#__PURE__*/_jsx(UITag, {
    inline: inline,
    use: "default",
    children: children
  });

  if (isEmbedded) {
    return renderedTag;
  }

  return /*#__PURE__*/_jsx(RouterFilterButton, Object.assign({}, rest, {
    use: "unstyled",
    children: renderedTag
  }));
};

RouterFilterTagButton.propTypes = {
  children: PropTypes.node,
  inline: PropTypes.bool
};
export default RouterFilterTagButton;